import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";
import { default as Header } from "../../Components/Header2/Header2";
import { default as Footer } from "../../Components/Footer/FooterSmall";
import SecHeader from "../../Components/SecHeader/SecHeader";
import useAPI from "../../Hooks/useAPI";
import Input from "../../Components/Input/Input";
import Button2 from "../../Components/Button2/Button2";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { forgotPassword } = useAPI();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      await forgotPassword(email);
      setSuccess(
        "If an account exists with this email, you will receive password reset instructions.",
      );
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    }
  };

  return (
    <>
      <div className="generalPage">
        <Header />
        <div className="pageContainer">
          <div className="forgot-password-title-container">
            <div className="sectionContainer">
              <SecHeader title="Forgot Password" iSize={3} />
            </div>
            <div className="forgot-password-container">
              <div className="forgot-password-card">
                <p className="forgot-password-subtitle">
                  Enter your email address and we'll send you instructions to
                  reset your password.
                </p>
                {error && <div className="error-message">{error}</div>}
                {success && <div className="success-message">{success}</div>}

                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label className="form-label" htmlFor="email">
                      Email
                    </label>
                    <Input
                      label=""
                      type="email"
                      id="email"
                      placeholder="Enter your email"
                      required={true}
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <Button2
                    name="submit"
                    text="Send Reset Instructions"
                    type="button"
                    classname="submit-btn"
                  />
                </form>

                <div className="mt-4 text-center">
                  <Button2
                    name="submit"
                    text="Back to Login"
                    type="button"
                    classname="cancel-btn"
                    onClick={() => navigate("/user-login")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
